import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ProductTypeCard, type ProductTypeConfig, useProductTypes } from '@/features/product-types';
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs';
import { useStanRouter } from '@/hooks/useStanRouter';
//TODO - Uncomment these when the generation is added
//import { StanButton } from '@/components';
//import { createIconElement } from '@/lib/utils/createIconElement';
//import LightbulbIconSvg from '@/assets/icons/ic-lightbulb.svg';

export default function AddProductPage() {
    const { storeId } = useParams<{ storeId: string }>();
    const { push } = useStanRouter();
    const { productTypes } = useProductTypes();
    //const LightbulbIcon = createIconElement(LightbulbIconSvg);

    useBreadcrumbs([
        { title: 'Home', to: '/dashboard', active: false, id: 'home' },
        { title: 'Choose Product Type', to: `/stores/${storeId}/page/create`, active: true, id: 'choose-product-type' },
    ]);

    // Redirect to /stores if storeId is not present
    useEffect(() => {
        if (!storeId) {
            push('/stores');
        }
    }, [storeId, push]);

    const handleProductTypeClick = (productType: ProductTypeConfig) => {
        if (productType.enabled && storeId) {
            push(`/stores/${storeId}/page/${productType.id}/create`);
        }
    };

    //TODO - Uncomment this when the generation is added
    // const handleGetProductIdeas = () => {};

    const pageContent = (
        <div className='flex flex-col gap-4'>
            <div className='mb-2'>
                <h1 className='text-dark pb-2'>Choose Product Type</h1>
                <p className='text-body-md text-gray'>
                    Pick the format that best fits what you&apos;re selling - guides, courses, coaching, or more!
                </p>
            </div>

            <div className='mb-3'>
                {/* //TODO - Uncomment this when the generation is added */}
                {/* <StanButton
                    name='get-product-ideas'
                    onClick={handleGetProductIdeas}
                    icon={LightbulbIcon}
                    color='primary'
                    size='md'
                >
                    Get product ideas
                </StanButton> */}
            </div>

            <div className='grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-2'>
                {productTypes.map(productType => (
                    <ProductTypeCard key={productType.id} productType={productType} onClick={handleProductTypeClick} />
                ))}
            </div>
        </div>
    );

    return pageContent;
}
